// Date-of-birth sanity checks. Phones' native date pickers open on today's
// date, and tapping OK without changing it saved the submission date as the
// client's DOB (seen live, 2026-10). Dates are the input's YYYY-MM-DD string.

/** Whole years between dob and today, or null if dob isn't a real date. */
export function ageInYears(dob, today = new Date()) {
  const match = /^(\d{4})-(\d{2})-(\d{2})$/.exec(String(dob || ''));
  if (!match) return null;
  const [year, month, day] = match.slice(1).map(Number);
  const birth = new Date(year, month - 1, day);
  if (birth.getFullYear() !== year || birth.getMonth() !== month - 1 || birth.getDate() !== day) return null;
  let age = today.getFullYear() - year;
  if (today.getMonth() < month - 1 || (today.getMonth() === month - 1 && today.getDate() < day)) age--;
  return age;
}

/** '' if dob is acceptable for someone who must be at least minAge, else a
 * message for the client. */
export function dobProblem(dob, minAge, today = new Date()) {
  const age = ageInYears(dob, today);
  if (age === null) return 'Please enter a valid date of birth.';
  if (Number(String(dob).slice(0, 4)) < 1900) return 'Please check the year of your date of birth.';
  if (age < 0) return 'Your date of birth can\'t be in the future. Please check it.';
  if (age < minAge) {
    return age === 0
      ? 'Your date of birth looks like today\'s date. Please enter your actual date of birth.'
      : `Please check your date of birth - you must be at least ${minAge} years old.`;
  }
  return '';
}
